import React from 'react';
import {
	DetailSection,
	DetailTitle,
	MetaGrid,
	MetaItem,
} from '../../callAnalysis.styles';

const ManualReviewSection = ({ manualReview }) => {
	if (!manualReview) {
		return null;
	}

	return (
		<DetailSection>
			<DetailTitle>Manual review</DetailTitle>
			<MetaGrid>
				<MetaItem>
					<strong>Status:</strong> {manualReview.status}
				</MetaItem>
				<MetaItem>
					<strong>Comment:</strong> {manualReview.comment || '—'}
				</MetaItem>
			</MetaGrid>
		</DetailSection>
	);
};

export default ManualReviewSection;
